var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M21.8 6.5c-4.35 0-7.9 2.95-7.9 6.6 0 2.25 1.3 4.25 3.35 5.45l-.45 3.05 3.35-1.85c.5.1 1 .15 1.55.15 4.35 0 7.9-2.95 7.9-6.6s-3.45-6.8-7.8-6.8zm-2.05 4.95a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm2.1 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm2.1 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M12.2 11.2c-4.7 0-8.5 3.15-8.5 7.05 0 2.4 1.45 4.55 3.7 5.9l-.5 3.25 3.65-1.95c.5.1 1.05.15 1.65.15 4.7 0 8.5-3.15 8.5-7.05s-3.8-7.35-8.5-7.35zm-2.25 5.25a1.1 1.1 0 1 1 0-2.2 1.1 1.1 0 0 1 0 2.2zm2.3 0a1.1 1.1 0 1 1 0-2.2 1.1 1.1 0 0 1 0 2.2zm2.3 0a1.1 1.1 0 1 1 0-2.2 1.1 1.1 0 0 1 0 2.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/chats.5e74eb8d3e53266b0962069460c07b3f.svg";
export { ForwardRef as ReactComponent };